export default "/Frontend/dist/csv-hover.67dacf7467f01a938eb723fe78b797b1.svg";